import AdminBar from './AdminBar'
import AdminTabs from './AdminTabs'
import ItemEditor from './ItemEditor'

export default Object.assign(
  theme => {
    return {
      
    }
  },
  {
    AdminBar,
    AdminTabs,
    ItemEditor
  }
)



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/adminView/generic/index.js